// Global error handler for unhandled promise rejections (401)
window.addEventListener('unhandledrejection', function(event) {
  if (event.reason && event.reason.response && event.reason.response.status === 401) {
    // Dispatch logout and redirect
    if (store) {
      store.dispatch('auth/logout');
    }
    if (router) {
      router.push('/home').catch(() => {});
    }
  }
});
import setupInterceptors from "./services/setupInterceptors";
import "./assets/main.css";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import store from "./store";

setupInterceptors(store);


import * as Sentry from "@sentry/vue";

Vue.config.productionTip = false;


Sentry.init({
  Vue,
  dsn: "https://473a9cb226ff789978861dfc109df0e3@o4508794503692288.ingest.de.sentry.io/4508794505986128",
  integrations: [
    Sentry.browserTracingIntegration({ router }),
    Sentry.replayIntegration(),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

new Vue({
  router,
  vuetify,
  store,
  render: (h) => h(App),
}).$mount("#app");
